'use strict';

import gsap from 'gsap';
import { GSAPAnimationMixer } from '../../settings';

export class GSAPMixers {
    constructor () {
        this.mixers = {};
        this.defaultEase = 'Power2.easeInOut';
        this.defaultDuration = 1;
    }

    registerNewMixer(name,deleteAfterEnd = true) {
        this.mixers[name] = new GSAPMixer(name,deleteAfterEnd);
        return this.mixers[name];
    }

    addToMixer(name,animation,time = 0) {
        const mixer = this.getMixer(name);
        mixer && mixer.addAnimation(animation,time);
    }

    play(name) {
        const mixer = this.getMixer(name);
        mixer && mixer.play();
    }

    deleteMixer(name) {
        if (this.mixers[name]) {
            this.mixers[name].dispose();
            delete this.mixers[name];
        }
    }

    getMixer(name) {
        return this.mixers[name];
    }

    get ease() {
        return this.defaultEase;
    }

    get duration() {
        return this.defaultDuration;
    }

    set ease(value) {
        this.defaultEase = value;
    }

    set duration(value) {
        this.defaultDuration = value;
    }

}

class GSAPMixer {
    constructor (name,deleteAfterEnd) {
        this.onStartCallback = [];
        this.onUpdateCallback = [];
        this.onCompleteCallback = [];
        this.animations = [];
        this.name = name;
        this.deleteAfterEnd = deleteAfterEnd;
    }

    addAnimation(animation,time = 0) {
        if (Array.isArray(this.animations)) {
            if (Array.isArray(animation)) {
                animation.forEach(animation => {
                    this.animations.push({
                        animation,
                        time
                    });
                })
            } else if (animation) {
                this.animations.push({
                    animation,
                    time
                });
            }
        }
    }

    addCallback(target,func) {
        switch (target) {
            case 'onStart':
                this.onStartCallback.push(func);
                break;
            case 'onUpdate':
                this.onUpdateCallback.push(func);
                break;
            case 'onComplete':
                this.onCompleteCallback.push(func);
                break;
        }
    }

    dispose() {
        this.onStartCallback = null;
        this.onUpdateCallback = null;
        this.onCompleteCallback = null;
        this.deleteAfterEnd = null;
        this.timeLine.kill();
        this.timeLine = null;
    }

    createTimeLine() {
        this.timeLine = gsap.timeline({
            paused: true,
            onStart: this.onStartCallback.length ? () => this.onStartCallback.forEach(func => func()) : null,
            onUpdate: this.onUpdateCallback.length ? () => this.onUpdateCallback.forEach(func => func()) : null,
            onComplete: () => {
                this.onCompleteCallback.forEach(func => func());
                this.deleteAfterEnd && GSAPAnimationMixer.deleteMixer(this.name);
            }
        });

        this.animations.forEach(obj => {
            this.timeLine.add(obj.animation,obj.time);
        });

        this.animations = null;

        return this.timeLine;
    }

    play() {
        if (!this.timeLine) {
            this.createTimeLine();
        }
        this.timeLine.play(0);
    }
}
